import { useMarketClockMs } from 'hooks/useMarketSessionClock';
import type { MarketSessionPhase } from 'utils/shared/time/marketSession';
import { todaysOpenInterestPhase } from './marketDataStatusModel';

/**
 * The session colour for the dot beside the OI totals, or null for no dot.
 *
 * Reads the one app-wide session clock, as the header dot does, so the two always agree, and turns
 * the dot off when the session closes without a new request. Null until the clock is read on the
 * client, so pre-rendered HTML never carries a dot.
 */
export default function useTodaysOpenInterestPhase(
  oiSessionDate: string | null | undefined,
): MarketSessionPhase | null {
  return todaysOpenInterestPhase(oiSessionDate, useMarketClockMs());
}
